import { Routes } from '@angular/router';
import * as RA from 'ramda-adjunct';
import {Screen} from '@emm/core/models/screen.model';
import {ManagementComponent} from '@emm/management/components/management/management.component';
import {ItemsComponent} from '@emm/management/components/items/items.component';
import {ConfirmItemsDeactivateGuard} from '@emm/shared/guards/confirm-items-deactivate.guard';
import {ItemGroupingsComponent} from '@emm/management/components/item-groupings/item-groupings.component';
import {ConfirmItemGroupingsDeactivateGuard} from '@emm/shared/guards/confirm-item-groupings-deactivate.guard';
import {ItemTypesComponent} from '@emm/management/components/item-types/item-types.component';
import {ConfirmItemTypesDeactivateGuard} from '@emm/shared/guards/confirm-item-types-deactivate.guard';
import {LocationSetTypesComponent} from '@emm/management/components/location-set-types/location-set-types.component';
import {ConfirmLocationSetTypesDeactivateGuard} from '@emm/shared/guards/confirm-location-set-types-deactivate.guard';
import {LocationSetsComponent} from '@emm/management/components/location-sets/location-sets.component';
import {ConfirmLocationSetsDeactivateGuard} from '@emm/shared/guards/confirm-location-sets-deactivate.guard';
import {
    ManagementAttributesComponent
} from '@emm/management/components/management-attributes/management-attributes.component';
import {
    ManagementAttributeGroupsComponent
} from '@emm/management/components/management-attribute-groups/management-attribute-groups.component';
import {OperatorLocksComponent} from '@emm/management/components/emergency-items/operator-locks.component';
import {ConsumerTypesComponent} from '@emm/management/components/consumer-types/consumer-types.component';
import {
    ManagementMasterMenuSystemComponent
} from '@emm/management/components/mms-revote/management-master-menu-system.component';
import {MmsAdminComponent} from '@emm/management/components/mms-admin/mms-admin.component';
import {
    NutritionAssignmentsComponent
} from '@emm/management/components/nutrition-assignments/nutrition-assignments.component';
import {ConsumerManagerComponent} from '@emm/management/components/consumer-manager/consumer-manager.component';
import {
    LanguageAssignmentsComponent
} from '@emm/management/components/language-assignments/language-assignments.component';
import {ItemIdMappingsComponent} from '@emm/management/components/item-id-mappings/item-id-mappings.component';
import {OperationsComponent} from '@emm/management/components/operations/operations.component';
import {PinOverridesComponent} from '@emm/management/components/pin-overrides/pin-overrides.component';
import {ConfirmPinOverridesDeactivateGuard} from '@emm/shared/guards/confirm-pin-overrides-deactivate-guard';
import {ConfirmOperationsDeactivateGuard} from '@emm/shared/guards/confirm-operations-deactivate.guard';

export const routes: Routes = [
    {
        path: '',
        component: ManagementComponent,
        children: [
            { path: '', redirectTo: 'items', pathMatch: 'full' },
            {
                path: 'items',
                component: ItemsComponent,
                canDeactivate: [ConfirmItemsDeactivateGuard],
                data: {
                    name: 'Items',
                    title: 'Management - Items/Modifiers'
                },
            },
            {
                path: 'item-groupings',
                component: ItemGroupingsComponent,
                canDeactivate: [ConfirmItemGroupingsDeactivateGuard],
                data: {
                    name: 'Item Groupings',
                    title: 'Management - Item/Modifier Groupings'
                },
            },
            {
                path: 'item-types',
                component: ItemTypesComponent,
                canDeactivate: [ConfirmItemTypesDeactivateGuard],
                data: {
                    name: 'Item Types',
                    title: 'Management - Item Types'
                },
            },
            {
                path: 'location-set-types',
                component: LocationSetTypesComponent,
                canDeactivate: [ConfirmLocationSetTypesDeactivateGuard],
                data: {
                    name: 'Location Set Types',
                    title: 'Management - Location Set Types'
                },
            },
            {
                path: 'location-sets',
                component: LocationSetsComponent,
                canDeactivate: [ConfirmLocationSetsDeactivateGuard],
                data: {
                    name: 'Location Sets',
                    title: 'Management - Location Sets'
                },
            },
            {
                path: 'attributes',
                component: ManagementAttributesComponent,
                data: {
                    name: 'Attributes',
                    title: 'Management - Attributes'
                },
            },
            {
                path: 'attribute-groups',
                component: ManagementAttributeGroupsComponent,
                data: {
                    name: 'Attribute Groups',
                    title: 'Management - Attribute Groups'
                },
            },
            {
                path: 'operator-locks',
                component: OperatorLocksComponent,
                data: {
                    name: 'Operator Locks',
                    title: 'Management - Operator Locks'
                },
            },
            {
                path: 'consumer-types',
                component: ConsumerTypesComponent,
                data: {
                    name: 'Consumer Types',
                    title: 'Management - Consumer Types'
                },
            },
            {
                path: 'operations',
                component: OperationsComponent,
                canDeactivate: [ConfirmOperationsDeactivateGuard],
                data: {
                    name: 'Operations',
                    title: 'Management - Operations'
                },
            },
            {
                path: 'mms-revote',
                component: ManagementMasterMenuSystemComponent,
                data: {
                    name: 'MMS Revote',
                    title: 'Management - MMS Revote'
                },
            },
            {
                path: 'mms-admin-override',
                component: MmsAdminComponent,
                data: {
                    name: 'MMS Admin Override',
                    title: 'Management - MMS Admin Override'
                },
            },
            {
                path: 'nutrition-assignments',
                component: NutritionAssignmentsComponent,
                data: {
                    name: 'Nutrition Assignments',
                    title: 'Management - Nutrition Assignments'
                },
            },
            {
                path: 'consumer-manager',
                component: ConsumerManagerComponent,
                data: {
                    name: 'Consumer Manager',
                    title: 'Management - Consumer Manager'
                },
            },
            {
                path: 'pin-overrides',
                component: PinOverridesComponent,
                canDeactivate: [ConfirmPinOverridesDeactivateGuard],
                data: {
                    name: 'PIN Overrides',
                    title: 'Management - PIN Overrides'
                },
            },
            {
                path: 'language-assignments',
                component: LanguageAssignmentsComponent,
                data: {
                    name: 'Language Assignments',
                    title: 'Management - Language Assignments'
                },
            },
            {
                path: 'item-id-mappings',
                component: ItemIdMappingsComponent,
                data: {
                    name: 'Xref Id Mappings',
                    title: 'Management - Xref Id Mappings'
                },
            }
        ]
    }
];

export const screens: Screen[] = routes[0].children
    .filter((route) => RA.isNonEmptyString(route.path))
    .map((route, index) => ({
        name: route.data.name,
        route: route.path,
        selected: index === 0
    }));
